import { detectionsApi } from '@/api/detections.api';
import type { DetectionModel } from '@/types/detection.types';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const useDetections = (projectId: string) => {
  const [detections, setDetections] = useState<DetectionModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDetections = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await detectionsApi.getByProjectId(projectId);
      setDetections(data);
    } catch (_err) {
      const message = 'Failed to load detections';
      setError(message);
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchDetections();
  }, [fetchDetections]);

  const deleteDetection = useCallback(
    async (extractionId: string) => {
      try {
        await detectionsApi.delete(extractionId);
        toast.success('Detection deleted');
        await fetchDetections(); // Refresh list
      } catch (err) {
        toast.error('Failed to delete detection');
        throw err;
      }
    },
    [fetchDetections]
  );

  return {
    detections,
    isLoading,
    error,
    refetch: fetchDetections,
    deleteDetection,
  };
};
